// export const ACTION_ADD_DEVICE = "addDeviceAction";
// export const ACTION_DELETE_DEVICE = "deleteDeviceAction";
// export const ACTION_UPDATE_DEVICE = "updateDeviceAction";
// export const ACTION_BROADCAST_DEVICE_ADDED = "deviceAddedBroadcastAction";
// export const ACTION_BROADCAST_DEVICE_DELETED = "deviceDeletedBroadcastAction";
// export const ACTION_BROADCAST_DEVICE_UPDATED = "deviceUpdatedBroadcastAction";
export const ACTION_UPDATE_DEVICE_MAP = "updateDeviceMapAction";
export const ACTION_UPDATE_DEVICECOUNT_OBJ = "updateDeviceCountObjAction";

// export const addDeviceAction = (payload) => ({
//   type: ACTION_UPDATE_DEVICE,
//   payload
// });

// export const deleteDeviceAction = (payload) => ({
//   type: ACTION_UPDATE_DEVICE,
//   payload
// });

// export const updateDeviceAction = (payload) => ({
//     type: ACTION_UPDATE_DEVICE,
//     payload
// });

// export const deviceAddedBroadcastAction = () => ({
//   type: ACTION_UPDATE_DEVICE
// });

// export const deviceDeletedBroadcastAction = () => ({
//   type: ACTION_UPDATE_DEVICE
// });

// export const deviceUpdatedBroadcastAction = () => ({
//     type: ACTION_UPDATE_DEVICE
// });

export const updateDeviceMapAction = (payload) => ({
  type: ACTION_UPDATE_DEVICE_MAP,
  payload
});

export const updateDeviceCountObjAction = (payload) => ({
  type: ACTION_UPDATE_DEVICECOUNT_OBJ,
  payload
});